const SSO_SCOPE = 'openid profile email phone address';
export const getRedirectUrl = (path) => `${window.location.origin}${path}`;
export const buildAuthorizeUrl = ({ ssoBaseUrl, clientId, sid, redirectPath, state, prompt, }) => {
    const params = new URLSearchParams({
        client_id: clientId,
        scope: SSO_SCOPE,
        response_type: 'code',
        sid,
        redirect_uri: getRedirectUrl(redirectPath),
        state,
    });
    if (prompt) {
        params.set('prompt', prompt);
    }
    return `${ssoBaseUrl}/authorize?${params.toString()}`;
};
